import React from 'react';
import { __ } from 'i18n/index';

import { JqueryClassFaker } from 'components/JqueryClassFaker.jsx';
import { UserComponent } from 'react/UserComponent.jsx';

export class CharacterComponent extends React.PureComponent {
	static defaultProps = {
		showCharacterName: true,
		useImgTag: false,
	};

	constructor(props) {
		super(props);
		this.characterClick = props.onClick && props.onClick.bind(null, props.character);
	}

	render() {
		// randomCharacter: what a Random pick landed on, drawn small in the corner.
		const { character, randomCharacter, percentage, extraClasses, showCharacterName, selectedByPlayers, imageOverride, useImgTag } = this.props;
		let { maxHeight, maxWidth } = this.props;

		const classes = new JqueryClassFaker(this.props.extraClasses);
		classes.add('character')
			.add('character_id_' + character.id);
		if(useImgTag) {
			classes.add('imaged');
		}
		else {
			classes
				.add('character_name_' + character.slug_name)
				.add('character_for_game_' + character.game_slug)
				.add(`character_dimensions_${character.width}_${character.height}`);
		}

		if(extraClasses) {
			classes.add(extraClasses);
		}

		let originalWidth = character.width;
		let originalHeight = character.height;
		if(!maxWidth) {
			maxWidth = originalWidth;
		}
		if(!maxHeight) {
			maxHeight = originalHeight;
		}

		let width = undefined;
		let height = undefined;
		if(originalWidth && originalHeight) {
			const dimensions = calculateAspectRatioFit(originalWidth, originalHeight, maxWidth, maxHeight);
			width = dimensions.width;
			height = dimensions.height;
		}

		if(this.characterClick) {
			classes.add('clickable');
		}

		let selectedByPlayersComponents = null;
		if(selectedByPlayers) {
			selectedByPlayersComponents = [];
			for(let player of selectedByPlayers) {
				selectedByPlayersComponents.push(
					<UserComponent
						key={player.id}
						user={player}
					/>
				);
			}
		}
		let imageToDisplay = null;
		if(imageOverride) {
			imageToDisplay = imageOverride;
		}
		else if(character.image_url) {
			imageToDisplay = character.image_url;
		}
		else {

		}


		let style = {
			backgroundImage: imageToDisplay ? `url(${imageToDisplay})` : null,
			width: width,
			height: height
		};

		if(useImgTag) {
			style = {};
		}

		return (
			<div
				onClick={this.characterClick}
				data-character-id={character.id}
				className={classes.toString()}
				title={character.name}
				style={style}
			>
				{useImgTag && imageToDisplay &&
				<img
					className='character_image'
					src={imageToDisplay}
					alt={character.name}
					title={character.name}
				/>
				}
				{!imageToDisplay &&
				<div className='no_image'>{character.name || 'No Image'}</div>
				}
				{randomCharacter &&
				<img title={__('Landed on %s', randomCharacter.name)} alt={__('Landed on %s', randomCharacter.name)} className='random_character_image' src={randomCharacter.image_url} />
				}
				{showCharacterName &&
				<span className='name'>{character.name}</span>
				}
				{percentage &&
				<span className='badge percentage'>{percentage}</span>
				}
				{!!selectedByPlayersComponents &&
				<div className='selected_by_players'>
					{selectedByPlayersComponents}
				</div>
				}
			</div>
		);
	}
}

function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
	const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	return { width: srcWidth * ratio, height: srcHeight * ratio };
}